import { useState, useEffect } from 'react'
import { ticketsService, locatariosService, actualizacionesService } from '../services/api'
import { IconSearch, IconPlus, IconBrandWhatsapp, IconMail, IconWorld, IconSparkles, IconLink, IconTrash, IconChartBar, IconPaperclip, IconX, IconFileTypePdf, IconDownload } from '@tabler/icons-react'

const PROYECTOS = ['DANA', 'LA NUBE', 'Arbol', 'CASSEA', 'DAHLIA', 'Citrus', 'MAGNOLIA', 'West Retail', 'Área comercial 02', 'UVAH', 'East Retail', 'ACOM', 'Island Retail', 'Mentha Retail']
const CATEGORIAS = ['queja', 'solicitud_servicio', 'duda_administrativa', 'pago', 'mantenimiento', 'actualizacion_datos', 'emergencia', 'otro']

export default function Tickets() {
  const [tickets, setTickets] = useState([])
  const [total, setTotal] = useState(0)
  const [seleccionado, setSeleccionado] = useState(null)
  const [solicitudesDatos, setSolicitudesDatos] = useState([])
  const [buscar, setBuscar] = useState('')
  const [soloSinAtencion, setSoloSinAtencion] = useState(false)
  const [estado, setEstado] = useState('')
  const [canal, setCanal] = useState('')
  const [cuentaOrigen, setCuentaOrigen] = useState('')
  const [proyecto, setProyecto] = useState('')
  const [categoria, setCategoria] = useState('')
  const [pagina, setPagina] = useState(1)
  const [loading, setLoading] = useState(true)
  const [respuesta, setRespuesta] = useState('')
  const [enviando, setEnviando] = useState(false)
  const [mostrarNuevo, setMostrarNuevo] = useState(false)
  const [nuevoTicket, setNuevoTicket] = useState({ locatarioId: '', canal: 'manual', asunto: '', descripcion: '' })
  const [buscarNuevoResidente, setBuscarNuevoResidente] = useState('')
  const [residenteNuevoSeleccionado, setResidenteNuevoSeleccionado] = useState(null)
  const [locatarios, setLocatarios] = useState([])
  const [creando, setCreando] = useState(false)
  const [buscarVincular, setBuscarVincular] = useState('')
  const [residenteVincular, setResidenteVincular] = useState(null)
  const [vinculando, setVinculando] = useState(false)
  const [descartando, setDescartando] = useState(false)
  const [mostrarEstadisticas, setMostrarEstadisticas] = useState(false)
  const [estadisticas, setEstadisticas] = useState(null)
  const [cargandoStats, setCargandoStats] = useState(false)
  const [archivoAdjunto, setArchivoAdjunto] = useState(null)
  const [subiendoArchivo, setSubiendoArchivo] = useState(false)
  const [mostrarReporte, setMostrarReporte] = useState(false)
  const [fuenteReporte, setFuenteReporte] = useState('filtros')
  const [fechaInicioReporte, setFechaInicioReporte] = useState('')
  const [fechaFinReporte, setFechaFinReporte] = useState('')
  const [generandoReporte, setGenerandoReporte] = useState('')

  useEffect(() => { cargar() }, [buscar, soloSinAtencion, estado, canal, cuentaOrigen, proyecto, categoria, pagina])

  useEffect(() => {
    locatariosService.listar({ limit: 2000 }).then(r => setLocatarios(r.data.data || []))
  }, [])

  const cargar = async () => {
    setLoading(true)
    try {
      const res = await ticketsService.listar({ buscar, sinAtencion: soloSinAtencion ? 'true' : undefined, estado, canal, cuentaOrigen, proyecto, categoria, page: pagina, limit: 20 })
      setTickets(res.data.data || [])
      setTotal(res.data.total || 0)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const verEstadisticas = async () => {
    setMostrarEstadisticas(true)
    setCargandoStats(true)
    try {
      const res = await ticketsService.estadisticas({ estado, canal, cuentaOrigen, proyecto, categoria })
      setEstadisticas(res.data)
    } catch (err) { console.error(err) }
    finally { setCargandoStats(false) }
  }

  const verDetalle = async (t) => {
    const res = await ticketsService.obtener(t.id)
    setSeleccionado(res.data)
    setRespuesta('')
    setArchivoAdjunto(null)
    setBuscarVincular('')
    setResidenteVincular(null)
    if (t.noLeido) {
      setTickets(prev => prev.map(x => x.id === t.id ? { ...x, noLeido: false } : x))
    }
    try {
      const resSolicitudes = await actualizacionesService.listar({ ticketId: t.id, estado: 'pendiente' })
      setSolicitudesDatos(resSolicitudes.data)
    } catch (err) { setSolicitudesDatos([]) }
  }

  const confirmarSolicitudDatos = async (id) => {
    try {
      await actualizacionesService.confirmar(id, {})
      const res = await actualizacionesService.listar({ ticketId: seleccionado.id, estado: 'pendiente' })
      setSolicitudesDatos(res.data)
    } catch (err) { console.error(err) }
  }

  const usarRespuestaIA = () => {
    if (!seleccionado?.mensajes) return
    const mensajesIA = seleccionado.mensajes.filter(m => m.esIa)
    const ultimaIA = mensajesIA[mensajesIA.length - 1]
    if (ultimaIA) setRespuesta(ultimaIA.contenido)
  }

  const seleccionarArchivo = async (e) => {
    const file = e.target.files[0]
    if (!file) return
    setSubiendoArchivo(true)
    try {
      const res = await ticketsService.subirArchivo(file)
      setArchivoAdjunto(res.data)
    } catch (err) {
      console.error(err)
      alert('Error al subir el archivo')
    } finally {
      setSubiendoArchivo(false)
    }
  }

  const enviarRespuesta = async () => {
    if (!respuesta.trim() && !archivoAdjunto) return
    setEnviando(true)
    try {
      await ticketsService.responder(seleccionado.id, {
        contenido: respuesta,
        archivoUrl: archivoAdjunto?.url || null,
        archivoNombre: archivoAdjunto?.nombre || null,
        tipoContenido: archivoAdjunto?.tipoContenido || 'texto'
      })
      const res = await ticketsService.obtener(seleccionado.id)
      setSeleccionado(res.data)
      setRespuesta('')
      setArchivoAdjunto(null)
      cargar()
    } catch (err) { console.error(err) }
    finally { setEnviando(false) }
  }

  const cambiarEstado = async (nuevoEstado) => {
    await ticketsService.actualizar(seleccionado.id, { estado: nuevoEstado })
    const res = await ticketsService.obtener(seleccionado.id)
    setSeleccionado(res.data)
    cargar()
  }

  const crearTicket = async () => {
    if (!residenteNuevoSeleccionado || !nuevoTicket.asunto || !nuevoTicket.descripcion) return
    setCreando(true)
    try {
      await ticketsService.crear({ ...nuevoTicket, locatarioId: residenteNuevoSeleccionado.id })
      setMostrarNuevo(false)
      setNuevoTicket({ locatarioId: '', canal: 'manual', asunto: '', descripcion: '' })
      setBuscarNuevoResidente('')
      setResidenteNuevoSeleccionado(null)
      cargar()
    } catch (err) { console.error(err) }
    finally { setCreando(false) }
  }

  const descargarReporte = async (formato) => {
    setGenerandoReporte(formato)
    try {
      const params = fuenteReporte === 'fechas'
        ? { fechaInicio: fechaInicioReporte || undefined, fechaFin: fechaFinReporte || undefined }
        : { buscar, estado, canal, cuentaOrigen, proyecto, categoria }

      const res = formato === 'excel' ? await ticketsService.reporteExcel(params) : await ticketsService.reportePDF(params)
      const blob = new Blob([res.data], { type: formato === 'excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'reporte-tickets-district-cooling.' + (formato === 'excel' ? 'xlsx' : 'pdf')
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.error(err)
      alert('Error al generar el reporte')
    } finally {
      setGenerandoReporte('')
    }
  }

  const vincularResidente = async () => {
    if (!residenteVincular) return
    setVinculando(true)
    try {
      await ticketsService.vincular(seleccionado.id, residenteVincular.id)
      const res = await ticketsService.obtener(seleccionado.id)
      setSeleccionado(res.data)
      setBuscarVincular('')
      setResidenteVincular(null)
      cargar()
    } catch (err) { console.error(err) }
    finally { setVinculando(false) }
  }

  const descartarTicket = async () => {
    if (!window.confirm('¿Descartar este ticket? Quedará marcado como descartado y no aparecerá en tickets abiertos.')) return
    setDescartando(true)
    try {
      await ticketsService.descartar(seleccionado.id)
      setSeleccionado(null)
      cargar()
    } catch (err) { console.error(err) }
    finally { setDescartando(false) }
  }

  const canalIcon = (c) => {
    if (c === 'whatsapp') return <IconBrandWhatsapp size={13} />
    if (c === 'correo') return <IconMail size={13} />
    return <IconWorld size={13} />
  }

  const timeAgo = (date) => {
    const diff = Date.now() - new Date(date)
    const h = Math.floor(diff / 3600000)
    if (h < 1) return 'hace unos minutos'
    if (h < 24) return `hace ${h}h`
    return `hace ${Math.floor(h/24)}d`
  }

  const tieneRespuestaIA = seleccionado?.mensajes?.some(m => m.esIa)

  const residentesFiltrados = buscarVincular.trim()
    ? locatarios.filter(l =>
        l.nombre?.toLowerCase().includes(buscarVincular.toLowerCase()) ||
        l.subscriptionExternalId?.toLowerCase().includes(buscarVincular.toLowerCase()) ||
        l.email?.toLowerCase().includes(buscarVincular.toLowerCase())
      )
    : []

  return (
    <div style={{ display: 'flex', gap: 16, height: 'calc(100vh - 120px)' }}>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', minWidth: 220 }}>
            <IconSearch size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#8A8A7A' }} />
            <input
              className="form-input"
              style={{ paddingLeft: 30 }}
              placeholder="Buscar por unidad, residente o mensaje..."
              value={buscar}
              onChange={e => { setBuscar(e.target.value); setPagina(1) }}
            />
          </div>
          <select className="form-select" value={estado} onChange={e => { setEstado(e.target.value); setPagina(1) }}>
            <option value="">Todos los estados</option>
            <option value="abierto">Abiertos</option>
            <option value="en_proceso">En proceso</option>
            <option value="resuelto">Resueltos</option>
            <option value="descartado">Descartados</option>
          </select>
          <select className="form-select" value={canal} onChange={e => { setCanal(e.target.value); setPagina(1) }}>
            <option value="">Todos los canales</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="correo">Correo</option>
            <option value="portal">Portal</option>
            <option value="manual">Manual</option>
          </select>
          <select className="form-select" value={cuentaOrigen} onChange={e => { setCuentaOrigen(e.target.value); setPagina(1) }}>
            <option value="">Atencion + Facturacion</option>
            <option value="atencion">Solo Atencion</option>
            <option value="facturacion">Solo Facturacion</option>
          </select>
          <select className="form-select" value={proyecto} onChange={e => { setProyecto(e.target.value); setPagina(1) }}>
            <option value="">Todos los edificios</option>
            {PROYECTOS.map(p => <option key={p} value={p}>{p}</option>)}
          </select>
          <select className="form-select" value={categoria} onChange={e => { setCategoria(e.target.value); setPagina(1) }}>
            <option value="">Todas las categorías</option>
            {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <button
            className="btn"
            onClick={() => { setSoloSinAtencion(v => !v); setPagina(1) }}
            style={{ display: 'flex', alignItems: 'center', gap: 6, background: soloSinAtencion ? '#C0392B' : '', color: soloSinAtencion ? '#fff' : '', borderColor: soloSinAtencion ? '#C0392B' : '' }}>
            🚨 Sin atención 2+ días
          </button>
          <div style={{ flex: 1 }} />
          <button className="btn" onClick={verEstadisticas} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <IconChartBar size={15} /> Estadísticas
          </button>
          <button className="btn" onClick={() => setMostrarReporte(true)} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <IconDownload size={15} /> Descargar reporte
          </button>
          <button className="btn btn-primary" onClick={() => setMostrarNuevo(true)}>
            <IconPlus size={15} /> Nuevo ticket
          </button>
        </div>

        <div className="card" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: 0 }}>
          <div style={{ padding: '10px 16px', borderBottom: '1px solid #D4C9B0', fontSize: 12, color: '#8A8A7A' }}>
            {total} tickets encontrados
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {loading && <div style={{ padding: 24, textAlign: 'center', color: '#8A8A7A' }}>Cargando...</div>}
            {!loading && tickets.map(t => (
              <div key={t.id} onClick={() => verDetalle(t)}
                style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', borderBottom: '1px solid #E8E0D0', cursor: 'pointer', background: seleccionado?.id === t.id ? '#F5EDDD' : (t.noLeido ? '#FDF8ED' : '') }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: t.noLeido ? '#C0392B' : 'transparent', flexShrink: 0 }} title={t.noLeido ? 'No leido' : ''} />
                <div className={`prio-dot prio-${t.prioridad}`} />
                <div style={{ fontSize: 12, color: '#8A8A7A', width: 40, flexShrink: 0 }}>#{t.id}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: t.noLeido ? 700 : 500, color: t.noLeido ? '#1C1C1A' : '', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.asunto}</div>
                  <div className="text-muted" style={{ marginTop: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                    {canalIcon(t.canal)} {t.locatario?.nombre} · {t.locatario?.subscriptionExternalId}
                    {t.cuentaOrigen && <span style={{ marginLeft: 4, fontSize: 10, padding: '1px 6px', borderRadius: 4, background: t.cuentaOrigen === 'facturacion' ? '#EAF3DE' : '#F5EDDD' }}>{t.cuentaOrigen}</span>}
                    {t.sinUnidadIdentificada && <span style={{ marginLeft: 4, fontSize: 10, padding: '1px 6px', borderRadius: 4, background: '#FAECE7', color: '#993C1D' }}>sin unidad</span>}
                  </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 }}>
                  {t.sinAtencionHumana && <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', background: '#C0392B', padding: '1px 6px', borderRadius: 4 }}>🚨 SIN ATENCIÓN</span>}
                  <span className={`badge badge-${t.estado}`}>{t.estado}</span>
                  {t.agente && <span style={{ fontSize: 10, color: '#8A6930' }}>👤 {t.agente.nombre}</span>}
                  <span style={{ fontSize: 11, color: '#8A8A7A' }}>{timeAgo(t.ultimaActividadAt || t.createdAt)}</span>
                </div>
              </div>
            ))}
          </div>
          <div style={{ padding: '10px 16px', borderTop: '1px solid #D4C9B0', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            <button className="btn btn-sm" onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={pagina === 1}>← Anterior</button>
            <span style={{ fontSize: 12, color: '#8A8A7A', alignSelf: 'center' }}>Página {pagina}</span>
            <button className="btn btn-sm" onClick={() => setPagina(p => p + 1)} disabled={tickets.length < 20}>Siguiente →</button>
          </div>
        </div>
      </div>

      {seleccionado && (
        <div className="card" style={{ width: 320, flexShrink: 0, display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden' }}>
          <div style={{ padding: 16, borderBottom: '1px solid #D4C9B0' }}>
            <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 4 }}>{seleccionado.asunto}</div>
            <div className="text-muted">{seleccionado.locatario?.nombre} · {seleccionado.locatario?.subscriptionExternalId}</div>
            <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
              <span className={`badge badge-${seleccionado.prioridad}`}>{seleccionado.prioridad}</span>
              <span className={`badge badge-${seleccionado.estado}`}>{seleccionado.estado}</span>
              <span className="badge badge-ia">IA activa</span>
              {seleccionado.sinUnidadIdentificada && <span className="badge" style={{ background: '#FAECE7', color: '#993C1D' }}>Sin unidad identificada</span>}
            </div>
            {seleccionado.agente && (
              <div style={{ fontSize: 12, color: '#8A6930', marginTop: 6 }}>👤 Atendido por {seleccionado.agente.nombre}</div>
            )}
          </div>

          {seleccionado.sinUnidadIdentificada && (
            <div style={{ padding: 12, borderBottom: '1px solid #D4C9B0', background: '#FDFAF4' }}>
              <div style={{ fontSize: 12, marginBottom: 8, color: '#5A5A50' }}>
                No pudimos identificar la unidad de este remitente. Vincula a un residente existente o descarta el ticket.
              </div>
              <div style={{ position: 'relative', marginBottom: 6 }}>
                <IconSearch size={13} style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', color: '#8A8A7A' }} />
                <input
                  className="form-input"
                  style={{ paddingLeft: 26, fontSize: 12 }}
                  placeholder="Buscar residente por nombre, unidad o correo..."
                  value={buscarVincular}
                  onChange={e => { setBuscarVincular(e.target.value); setResidenteVincular(null) }}
                />
              </div>
              {buscarVincular && !residenteVincular && (
                <div style={{ border: '1px solid #D4C9B0', borderRadius: 6, maxHeight: 140, overflowY: 'auto', marginBottom: 6 }}>
                  {residentesFiltrados.slice(0, 8).map(l => (
                    <div key={l.id} onClick={() => { setResidenteVincular(l); setBuscarVincular(l.subscriptionExternalId + ' — ' + l.nombre) }}
                      style={{ padding: '6px 10px', cursor: 'pointer', borderBottom: '1px solid #E8E0D0', fontSize: 12 }}>
                      <span style={{ fontFamily: 'monospace', fontWeight: 500 }}>{l.subscriptionExternalId}</span> — {l.nombre}
                    </div>
                  ))}
                  {residentesFiltrados.length === 0 && <div style={{ padding: '6px 10px', color: '#8A8A7A', fontSize: 12 }}>Sin resultados</div>}
                </div>
              )}
              <div style={{ display: 'flex', gap: 6 }}>
                <button className="btn btn-sm" onClick={descartarTicket} disabled={descartando} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                  <IconTrash size={13} /> {descartando ? 'Descartando...' : 'Descartar'}
                </button>
                <button className="btn btn-sm btn-primary" onClick={vincularResidente} disabled={!residenteVincular || vinculando} style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                  <IconLink size={13} /> {vinculando ? 'Vinculando...' : 'Vincular'}
                </button>
              </div>
            </div>
          )}

          {solicitudesDatos.filter(s => s.estado === 'pendiente').map(s => (
            <div key={s.id} style={{ padding: 12, borderBottom: '1px solid #D4C9B0', background: '#FDF6E8' }}>
              <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6, color: '#8A6930' }}>📝 Solicitud de actualización de datos pendiente</div>
              <div style={{ fontSize: 12, color: '#5A5A50', display: 'flex', flexDirection: 'column', gap: 2, marginBottom: 8 }}>
                {s.telefono && <div>Teléfono nuevo: {s.telefono}</div>}
                {s.correoAlterno && <div>Correo nuevo: {s.correoAlterno}</div>}
                {s.correoAlterno2 && <div>Correo alterno 2: {s.correoAlterno2}</div>}
                {s.correoAlterno3 && <div>Correo alterno 3: {s.correoAlterno3}</div>}
                {s.rfc && <div>RFC: {s.rfc}</div>}
                {s.razonSocial && <div>Razón social: {s.razonSocial}</div>}
                {s.direccionFacturacion && <div>Dirección facturación: {s.direccionFacturacion}</div>}
                {s.codigoPostal && <div>Código postal: {s.codigoPostal}</div>}
                {s.regimenFiscalClave && <div>Régimen fiscal: {s.regimenFiscalClave}</div>}
                {s.usoCfdi && <div>Uso CFDI: {s.usoCfdi}</div>}
                {s.metodoPago && <div>Método de pago: {s.metodoPago}</div>}
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button className="btn btn-sm btn-primary" onClick={() => confirmarSolicitudDatos(s.id)} style={{ flex: 1 }}>Confirmar y notificar</button>
              </div>
            </div>
          ))}

          <div style={{ flex: 1, overflowY: 'auto', padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
            {seleccionado.mensajes?.map(m => (
              <div key={m.id} style={{ background: m.esIa ? (m.enviadoAuto ? '#DCEEFB' : '#EAF3DE') : m.origen === 'agente' ? '#F5EDDD' : '#F1EFE8', borderRadius: 8, padding: 10 }}>
                <div style={{ fontSize: 10, color: '#8A8A7A', marginBottom: 4 }}>
                  {m.esIa ? (m.enviadoAuto ? '🤖 IA · enviado al residente' : '🤖 Sugerencia IA · sin enviar') : m.origen === 'agente' ? '👤 Agente' : '🏠 Residente'} · {timeAgo(m.createdAt)}
                </div>
                {m.tipoContenido === 'image' && m.archivoUrl && (
                  <a href={m.archivoUrl} target="_blank" rel="noreferrer">
                    <img src={m.archivoUrl} alt="Adjunto" style={{ maxWidth: '100%', borderRadius: 6, marginBottom: m.contenido ? 6 : 0, display: 'block' }} />
                  </a>
                )}
                {m.tipoContenido === 'document' && m.archivoUrl && (
                  <a href={m.archivoUrl} target="_blank" rel="noreferrer"
                    style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#FFF', padding: 8, borderRadius: 6, marginBottom: m.contenido ? 6 : 0, textDecoration: 'none', color: '#1C1C1A' }}>
                    <IconFileTypePdf size={16} /> <span style={{ fontSize: 12 }}>{m.archivoNombre || 'Documento adjunto'}</span>
                  </a>
                )}
                {m.contenido && <div style={{ fontSize: 12, lineHeight: 1.5 }}>{m.contenido}</div>}
              </div>
            ))}
          </div>

          <div style={{ padding: 12, borderTop: '1px solid #D4C9B0' }}>
            {tieneRespuestaIA && (
              <button
                className="btn btn-sm"
                onClick={usarRespuestaIA}
                style={{ width: '100%', marginBottom: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
              >
                <IconSparkles size={14} /> Usar respuesta sugerida por IA
              </button>
            )}
            {archivoAdjunto && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#F5EDDD', padding: '6px 10px', borderRadius: 6, fontSize: 12, marginBottom: 8 }}>
                {archivoAdjunto.tipoContenido === 'image' ? '🖼️' : <IconFileTypePdf size={14} />} {archivoAdjunto.nombre}
                <button onClick={() => setArchivoAdjunto(null)} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', display: 'flex' }}>
                  <IconX size={14} />
                </button>
              </div>
            )}
            <textarea
              className="form-input"
              style={{ height: 70, resize: 'none', marginBottom: 8 }}
              placeholder="Escribe una respuesta o usa la sugerencia de la IA..."
              value={respuesta}
              onChange={e => setRespuesta(e.target.value)}
            />
            <div style={{ display: 'flex', gap: 6 }}>
              <label className="btn btn-sm" style={{ display: 'flex', alignItems: 'center', gap: 4, cursor: subiendoArchivo ? 'wait' : 'pointer' }}>
                <IconPaperclip size={14} />
                <input type="file" accept=".pdf,.png,.jpg,.jpeg,.xml,.doc,.docx,.xls,.xlsx" onChange={seleccionarArchivo} disabled={subiendoArchivo} style={{ display: 'none' }} />
              </label>
              <button className="btn btn-sm" onClick={() => cambiarEstado('resuelto')} style={{ flex: 1 }}>Resolver</button>
              <button className="btn btn-sm btn-primary" onClick={enviarRespuesta} disabled={enviando || subiendoArchivo} style={{ flex: 1 }}>
                {enviando ? 'Enviando...' : subiendoArchivo ? 'Subiendo...' : 'Enviar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {mostrarNuevo && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div className="card" style={{ width: 480, padding: 24 }}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 20 }}>Nuevo ticket</div>
            <div className="form-group">
              <label className="form-label">Residente</label>
              <div style={{ position: 'relative' }}>
                <IconSearch size={13} style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', color: '#8A8A7A' }} />
                <input
                  className="form-input"
                  style={{ paddingLeft: 26 }}
                  placeholder="Buscar por nombre, unidad o correo..."
                  value={buscarNuevoResidente}
                  onChange={e => { setBuscarNuevoResidente(e.target.value); setResidenteNuevoSeleccionado(null) }}
                />
              </div>
              {buscarNuevoResidente && !residenteNuevoSeleccionado && (
                <div style={{ border: '1px solid #D4C9B0', borderRadius: 6, maxHeight: 160, overflowY: 'auto', marginTop: 6 }}>
                  {locatarios.filter(l =>
                    l.nombre?.toLowerCase().includes(buscarNuevoResidente.toLowerCase()) ||
                    l.subscriptionExternalId?.toLowerCase().includes(buscarNuevoResidente.toLowerCase()) ||
                    l.email?.toLowerCase().includes(buscarNuevoResidente.toLowerCase())
                  ).slice(0, 8).map(l => (
                    <div key={l.id} onClick={() => { setResidenteNuevoSeleccionado(l); setBuscarNuevoResidente(l.subscriptionExternalId + ' — ' + l.nombre) }}
                      style={{ padding: '6px 10px', cursor: 'pointer', borderBottom: '1px solid #E8E0D0', fontSize: 12 }}>
                      <span style={{ fontFamily: 'monospace', fontWeight: 500 }}>{l.subscriptionExternalId}</span> — {l.nombre}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="form-group">
              <label className="form-label">Canal</label>
              <select className="form-input" value={nuevoTicket.canal} onChange={e => setNuevoTicket({ ...nuevoTicket, canal: e.target.value })}>
                <option value="manual">Manual</option>
                <option value="whatsapp">WhatsApp</option>
                <option value="correo">Correo</option>
                <option value="portal">Portal</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Asunto</label>
              <input className="form-input" placeholder="Describe brevemente el problema" value={nuevoTicket.asunto} onChange={e => setNuevoTicket({ ...nuevoTicket, asunto: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="form-label">Descripción</label>
              <textarea className="form-input" style={{ height: 80, resize: 'none' }} placeholder="Detalla la solicitud o queja..." value={nuevoTicket.descripcion} onChange={e => setNuevoTicket({ ...nuevoTicket, descripcion: e.target.value })} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn" onClick={() => setMostrarNuevo(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={crearTicket} disabled={creando}>
                {creando ? 'Creando con IA...' : 'Crear ticket'}
              </button>
            </div>
          </div>
        </div>
      )}

      {mostrarEstadisticas && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}
          onClick={() => setMostrarEstadisticas(false)}>
          <div className="card" style={{ width: 560, padding: 24, maxHeight: '85vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 4 }}>Estadísticas de tickets</div>
            <div className="text-muted" style={{ marginBottom: 20 }}>Según los filtros activos en este momento</div>

            {cargandoStats && <div style={{ textAlign: 'center', padding: 24, color: '#8A8A7A' }}>Cargando...</div>}

            {!cargandoStats && estadisticas && (
              <>
                <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Total: {estadisticas.total} tickets</div>

                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, color: '#8A8A7A', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Por edificio</div>
                  {estadisticas.porProyecto.map(p => (
                    <div key={p.nombre} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                      <div style={{ width: 140, fontSize: 12, flexShrink: 0 }}>{p.nombre}</div>
                      <div style={{ flex: 1, background: '#F1EFE8', borderRadius: 4, height: 16, overflow: 'hidden' }}>
                        <div style={{ width: (p.total / estadisticas.porProyecto[0].total * 100) + '%', background: '#8A6930', height: '100%' }} />
                      </div>
                      <div style={{ width: 30, fontSize: 12, textAlign: 'right', flexShrink: 0 }}>{p.total}</div>
                    </div>
                  ))}
                  {estadisticas.porProyecto.length === 0 && <div style={{ fontSize: 12, color: '#8A8A7A' }}>Sin datos</div>}
                </div>

                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 12, color: '#8A8A7A', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Por categoría</div>
                  {estadisticas.porCategoria.map(c => (
                    <div key={c.nombre} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                      <div style={{ width: 140, fontSize: 12, flexShrink: 0 }}>{c.nombre}</div>
                      <div style={{ flex: 1, background: '#F1EFE8', borderRadius: 4, height: 16, overflow: 'hidden' }}>
                        <div style={{ width: (c.total / estadisticas.porCategoria[0].total * 100) + '%', background: '#A0522D', height: '100%' }} />
                      </div>
                      <div style={{ width: 30, fontSize: 12, textAlign: 'right', flexShrink: 0 }}>{c.total}</div>
                    </div>
                  ))}
                </div>

                <div>
                  <div style={{ fontSize: 12, color: '#8A8A7A', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.4px' }}>Por estado</div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {estadisticas.porEstado.map(e => (
                      <span key={e.nombre} className={`badge badge-${e.nombre}`}>{e.nombre}: {e.total}</span>
                    ))}
                  </div>
                </div>
              </>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
              <button className="btn" onClick={() => setMostrarEstadisticas(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {mostrarReporte && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}>
          <div className="card" style={{ width: 440, padding: 24 }}>
            <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 18, marginBottom: 4 }}>Descargar reporte</div>
            <div className="text-muted" style={{ marginBottom: 16 }}>Incluye resumen y detalle de tickets</div>

            <div className="form-group">
              <label className="form-label">¿Sobre qué tickets?</label>
              <select className="form-input" value={fuenteReporte} onChange={e => setFuenteReporte(e.target.value)}>
                <option value="filtros">Los filtros que tengo activos en pantalla</option>
                <option value="fechas">Un rango de fechas específico</option>
              </select>
            </div>

            {fuenteReporte === 'fechas' && (
              <div style={{ display: 'flex', gap: 10 }}>
                <div className="form-group" style={{ flex: 1 }}>
                  <label className="form-label">Desde</label>
                  <input type="date" className="form-input" value={fechaInicioReporte} onChange={e => setFechaInicioReporte(e.target.value)} />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label className="form-label">Hasta</label>
                  <input type="date" className="form-input" value={fechaFinReporte} onChange={e => setFechaFinReporte(e.target.value)} />
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
              <button className="btn" onClick={() => setMostrarReporte(false)}>Cancelar</button>
              <button className="btn" onClick={() => descargarReporte('excel')} disabled={!!generandoReporte} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <IconDownload size={14} /> {generandoReporte === 'excel' ? 'Generando...' : 'Excel'}
              </button>
              <button className="btn btn-primary" onClick={() => descargarReporte('pdf')} disabled={!!generandoReporte} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <IconDownload size={14} /> {generandoReporte === 'pdf' ? 'Generando...' : 'PDF'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
